// Generated from source/ by scripts/generate.ts. Do not edit by hand.
import type { IconData } from "../types.js";

/** Box Open (features). */
const icon: IconData = {
  id: "box-open",
  name: "Box Open",
  category: "features",
  styles: {
    rounded: {
      svg: '<path d="M11 21.73V12.58L3 7.95V15.98Q3 16.53 3.26 16.98T4 17.7ZM13 21.73L20 17.7Q20.47 17.42 20.74 16.98T21 15.98V7.95L13 12.57ZM16.98 7.98L19.93 6.25 13 2.27Q12.53 2 12 2T11 2.28L9.03 3.4ZM12 10.85L14.98 9.15 7.06 4.55 4.06 6.28Z"/>',
    },
    sharp: {
      svg: '<path d="M11 21.73V12.58L3 7.95V17.13ZM13 21.73L21 17.13V7.95L13 12.57ZM16.98 7.98L19.93 6.25 12 1.7 9.03 3.4ZM12 10.85L14.98 9.15 7.06 4.55 4.06 6.28Z"/>',
    },
    outline: {
      svg: '<path d="M11 19.43V12.58L5 9.1V15.95ZM13 19.43L19 15.95V9.1L13 12.58ZM11 21.73L4 17.7Q3.53 17.42 3.26 16.98T3 15.98V8.03Q3 7.48 3.26 7.03T4 6.3L11 2.27Q11.47 2 12 2T13 2.28L20 6.3Q20.47 6.58 20.74 7.02T21 8.02V15.97Q21 16.52 20.74 16.97T20 17.7L13 21.73Q12.53 22 12 22T11 21.72M16 8.52L17.93 7.42 12 4 10.05 5.12ZM12 10.85L13.95 9.73 8.03 6.3 6.08 7.42Z"/>',
    },
    duotone: {
      svg: '<g opacity=".32"><path d="M12.52 2.07L13 2.28 20 6.3 20.42 6.62 20.74 7.02 20.94 7.49 21 8.02V15.97L20.93 16.5 20.74 16.97 20.43 17.38 20 17.7 13 21.73 12.52 21.93 12 22 11.48 21.93 11 21.73 4 17.7 3.58 17.38 3.26 16.98 3.06 16.51 3 15.98V8.03L3.06 7.5 3.26 7.03 3.58 6.62 4 6.3 11 2.27 11.48 2.07 12 2Z"/></g><path d="M11 19.43V12.58L5 9.1V15.95ZM13 19.43L19 15.95V9.1L13 12.58ZM11 21.73L4 17.7Q3.53 17.42 3.26 16.98T3 15.98V8.03Q3 7.48 3.26 7.03T4 6.3L11 2.27Q11.47 2 12 2T13 2.28L20 6.3Q20.47 6.58 20.74 7.02T21 8.02V15.97Q21 16.52 20.74 16.97T20 17.7L13 21.73Q12.53 22 12 22T11 21.72M16 8.52L17.93 7.42 12 4 10.05 5.12ZM12 10.85L13.95 9.73 8.03 6.3 6.08 7.42Z"/>',
    },
  },
  animation: () => import("../animations/box-open.js"),
};

export default icon;
